module.exports = __webpack_public_path__ + "img/default_user2.359be54b.png";